/**
 * messageTemplateのドキュメントデータ変換モジュール
 * @date 2025/06/25
 */
import { DocumentData } from 'firebase/firestore/lite';
import { MessageTemplateFromJson } from 'smartdishpro-scripts/ts_common';
import { MessageTemplate, toMessageTemplateId } from 'src/models/messageTemplate';

/**
 * FirestoreのドキュメントデータからmessageTemplateオブジェクトに変換
 * @param data Firestoreのドキュメントデータ
 * @param id ドキュメントID
 * @returns messageTemplateオブジェクト
 */
export const toMessageTemplateFromDoc = (
  data: DocumentData, 
  id: string
): MessageTemplate => {
  const _messageTemplate = MessageTemplateFromJson(data);

  return {
    ..._messageTemplate,
    id: toMessageTemplateId(id),
    key: id,
  };
};